import React from 'react';

interface IToggleCheckBoxProps {
  label?: string;
  selected: string;
  selectOption: (selected: string) => void;
  options: { label: string; value: string }[];
}

const SelectBox = ({
  label,
  selected,
  selectOption,
  options,
}: IToggleCheckBoxProps) => {
  return (
    <div className="w-full">
      <select
        value={selected}
        onChange={(e: any) => selectOption(e.target.value)}
        className="w-full border border-[#c9cccf] rounded-md px-3 py-2 text-sm text-[#202223] focus:outline-none focus:ring-1 focus:ring-[#2563EB] focus:border-[#2563EB] transition-all bg-white hover:border-[#a6acb3]"
      >
        {options.map((o) => (
          <option value={o.value} key={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectBox;
